<template>
  <div class="search-filter">
    <vxe-modal v-model="open" width="432" height="400" :show-footer="false" :showHeader="false">
      <template v-slot>
        <DatePicker
          :open="open"
          confirm
          type="datetimerange"
          format="yyyy-MM-dd"
          :split-panels="true"
          placeholder
          style="width: 432px"
          @on-change="handleChange"
          @on-clear="handleClear"
          @on-ok="handleOk"
        >
          <span class="date-slot"></span>
        </DatePicker>
      </template>
    </vxe-modal>
    <Poptip placement="bottom-end" width="680" v-model="visible">
      <em>
        <Icon type="ios-search-outline" />搜索
      </em>
      <div class="search-box" slot="content">
        <vxe-form
          :data="searchFormData"
          :items="searchFormItems"
          title-align="right"
          title-width="100"
          @submit="submitEvent"
        ></vxe-form>
      </div>
    </Poptip>
  </div>
</template>

<script>
export default {
  props: {
    searchFormData: Object,
    searchFormItems: Array,
  },
  data() {
    return {
      visible: false,
      timeVal: "",
      rangeTime: "time",
      open: false,
    };
  },
  computed: {},
  watch: {
    "searchFormData.time": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("time");
      },
    },
    "searchFormData.addTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("addTime");
      },
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
    "searchFormData.beginTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("beginTime");
      },
    },
    "searchFormData.endTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("endTime");
      },
    },
  },
  methods: {
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    submitEvent() {
      this.$emit("searchListKey", this.searchFormData);
      this.visible = false;
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {},
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.visible = true;
      }, 100);
    },
  },
};
</script>

<style>
.search-filter {
  float: right;
  height: 34px;
  line-height: 34px;
}
.search-filter em .ivu-icon {
  font-weight: bold;
  font-size: 18px;
  margin: 2px 3px 0 0;
}
.search-filter em {
  cursor: pointer;
  padding-right: 10px;
  font-size: 15px;
}
.search-filter em:hover {
  color: #409eff;
}
.search-filter em.sec-em {
  margin-left: 10px;
}
.ivu-poptip-popper {
  z-index: 10;
}
.search-filter .vxe-col--12 .vxe-form--item-title {
  display: block;
  position: absolute;
  left: 0;
  top: -28px;
}
.search-filter .vxe-form--item-inner {
  position: relative;
}
.search-filter .vxe-col--12 {
  margin-top: 30px;
}
.search-filter .vxe-col--24 .vxe-form--item-title {
  font-weight: bold;
}
.search-filter .vxe-input--inner {
  border-radius: 0;
}
.search-filter .vxe-modal--body {
  padding: 0;
}
.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--body,
.search-filter
  .vxe-modal--wrapper.type--modal
  .vxe-modal--body
  .vxe-modal--content {
  overflow: hidden;
}
.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--box {
  box-shadow: none;
  background: none;
  border: none;
}
.search-filter .search-box{
  min-height: 500px;
  max-height: 650px;
  overflow-y: scroll;
}
.search-filter .search-box .vxe-col--24.is--title {
  margin-top: 0;
}
.search-filter .search-box .vxe-col--24{
  margin-top: 50px;
}
</style>